import { useI18n } from '@bravemove/i18n/react/core';
import {
  LanguageSwitcher,
  type LanguageCode,
  type LanguageSwitcherProps,
} from './LanguageSwitcher';

export type ConnectedLanguageSwitcherProps = Omit<LanguageSwitcherProps, 'value' | 'onChange'>;

/**
 * LanguageSwitcher bound to the active i18n locale. Reads + writes through
 * `useI18n` from `@bravemove/i18n/react/core` (the DOM-free subset) so this file
 * stays inside `@bravemove/ui-web` without re-introducing the historic cycle
 * (ui-web → i18n/react → ui-web). Web-only; mobile uses its own switcher.
 */
export function ConnectedLanguageSwitcher(props: ConnectedLanguageSwitcherProps) {
  const { locale, setLocale } = useI18n();
  return (
    <LanguageSwitcher
      {...props}
      value={locale as LanguageCode}
      onChange={(code) => {
        void setLocale(code);
      }}
    />
  );
}
